import { Component, Input, OnInit, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { FileUploadService } from 'src/app/core/service/file-upload.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Utils} from '../../../utils/utils';
import { Alerts } from 'src/app/utils/alert';
import { TypeAlert } from 'src/app/shared/constants/enums.interface';

@Component({
  selector: 'app-fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.css'],
  standalone: false
})
export class FileuploadComponent implements OnInit {

  @Output() dataEvent = new EventEmitter<string>();
  @Input() validextension: string ="";
  @Input() customValidationFunction: (() => boolean | any) | undefined;
  @Input() permiteMultiples: boolean = false;

  @ViewChild("fileInput", {static: false})
  fileInput: ElementRef | undefined;

  /* @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>; */

  currentFile?: File | null;
  progress = 0;
  message = '';

  fileName = 'Seleccionar Archivo';
  fileInfos?: Observable<any>;
  file1Bytes: string ="";

  constructor(
    private uploadService: FileUploadService,
    private alerts: Alerts,
    ) { }

  ngOnInit(): void {
    this.fileInfos = this.uploadService.getFiles();
  }

  selectFile(event: any): any {

    if (event.target.files?.[0]){

        let extensionesValidas = this.validextension.split(',');

        if (this.permiteMultiples) {

          const archivos: FileList = event.target.files;        
          const archivosNombres: string[] = [];

          for (let i = 0; i < archivos.length; i++) {

            const archivo = archivos[i];
            const nombre = archivo.name;
            const busext = Utils.notRepetSearch(nombre, ".");
            const extension = nombre.split(".")[busext];
        
            if (!extensionesValidas.includes(extension)) {
              this.alerts.Notificacion(
                TypeAlert.Validation,
                `El archivo ${nombre} no cumple el formato .${extensionesValidas.join(', .')}`,
                "Validación"
              );
              this.reset();
              return;
            }
        
            archivosNombres.push(nombre);            

          }

          this.fileName = archivosNombres.join(', ');

        } else {

          const file: File = event.target.files[0];
          this.currentFile = file;
          this.fileName = this.currentFile.name;
          let busext = Utils.notRepetSearch(this.fileName, ".");
          let extension = this.currentFile.name.split(".")[busext];
          
          if( !extensionesValidas.includes(extension) ){
            this.alerts.Notificacion(TypeAlert.Validation, `El archivo ${this.fileName} no cumple el formato .${extensionesValidas.join(', .')}` , "Validación");
            return this.reset();
          }
          const reader = new FileReader();
          reader.onload = (e) => {
            this.file1Bytes = reader.result!.toString().trim();
          };
          reader.readAsDataURL(this.currentFile);
          reader.onloadend = () => {
            this.dataEvent.emit(this.file1Bytes);
          }

        }
      } else {

        this.fileName = 'Seleccionar Archivo';
        this.dataEvent.emit(undefined);

      }
  }

  beforeFileSelect(event: MouseEvent): void {
    if (this.customValidationFunction && !this.customValidationFunction()) {
      // La validación falla, prevenir que se abra el explorador de archivos
      event.preventDefault();
      // Aquí puedes añadir cualquier lógica adicional, como mostrar un mensaje de error
    }
  }

  upload(): void {
    this.progress = 0;
    this.message = "";
    if (this.currentFile) {
      this.uploadService.upload(this.currentFile).subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            this.message = event.body.message;
            this.fileInfos = this.uploadService.getFiles();
          }
          else{
            this.message="No se cargó correctamente el archivo"
          }
        },
        error: (err: any) => {
          console.error(err);
          this.progress = 0;
          this.currentFile = null;
        }
      });
    }
  }

  reset(){
    this.fileInput!.nativeElement.value="";
    this.fileName = 'Seleccionar Archivo';
    this.file1Bytes = "";
  }

  /* openFileDialog() {
    this.fileInput.nativeElement.click();
  } */
}